import { Route } from "react-router-dom";
import PrestadorContainer from "../ui/art/prestadores/prestadorContainer";
import ArtSearchContainer from "../ui/art/siniestros/ArtSearchContainer";

const ArtAccidentRoutes = () => (
  <>
    <Route path="/art/prestadores" element={<PrestadorContainer />} />
    <Route path="/art/accidents/search" element={<ArtSearchContainer />} />
  </>
);

export default ArtAccidentRoutes;
